import { ShippingDTO } from 'models/shipping'
import { Constraints } from '@touche-lts/panel-ui/dist'

// export const shippingFormConstraints: Constraints<ShippingDTO> = {
//   chronoUnit: {
//     presence: true
//   },
//   deliveryTime: {
//     presence: true
//   },
//   name: {
//     presence: true,
//     length: { minimum: 2 }
//   },
//   freeAmount: { numericality: { greaterThan: 0, strict: true } },
//   price: { numericality: { greaterThan: 0, strict: true } }
// }

export const getShippingFormConstraints = (options?: {
  freeShipping?: boolean
  freeShippingAbove?: boolean
}): Constraints<ShippingDTO> => {
  const constraints: Constraints<ShippingDTO> = {
    chronoUnit: {
      presence: true
    },
    deliveryTime: {
      presence: true,
      length: { minimum: 1 }
    },
    name: {
      presence: true,
      length: { minimum: 2 }
    },
    price: { numericality: { strict: false } },
    freeAmount: { numericality: { strict: false } },
    countries : {
      length: { minimum: 1 }
    }
  }

  if (!options?.freeShipping) {
    constraints.price = {
      numericality: { greaterThan: 0, strict: true },
      presence: true
    }
    if (options?.freeShippingAbove) {
      constraints.freeAmount = {
        numericality: { greaterThan: 0, strict: true },
        presence: true
      }
    }
  }

  return constraints
}
